<template>
<div>
  <div class="title">
    <h2 class="section-title"> Sediu</h2>
  </div>
  <SliderImages />
  <div class="office-container">
    <div class="title">
      <p><i class="contact-icon fa fa-map-marker"></i> <strong>Adresa: </strong>
        {{ address }}
      </p>
    </div>
    <div class="map-image" @mouseenter="isOverlay = true" @mouseleave="isOverlay = false">
      <img src="../assets/sediu.png">
      <div class="map-overlay" v-if="isOverlay">
        <a :href="mapLink" target="_blank" class="search-icon-map">
          <i class="fa fa-search"></i> 
          <span class="map-link">Vezi harta</span>  
        </a>
      </div>
    </div>
  </div>
  
</div>
</template>
<script>
import { ADDRESS, MAP_LINK } from '../constants';
import SliderImages from './SliderImages.vue';
export default {
  name: 'Office',
  components: { SliderImages },
  data() {
    return {
      address: ADDRESS,
      isOverlay: false,
      mapLink: MAP_LINK,
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../scss/_variables.scss";
.section-title {
  margin-bottom: 0;
}
.office-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
}
.title {
  text-align: center;
  padding: 0 15px;
  margin-bottom: 10px;
  p {
    font-size: 18px;
  }
}
.office-container p {
  margin-bottom: 5px;
}
.map-image {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .map-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
  }

  .search-icon-map {
    text-decoration: none;
    position: absolute;
    font-size: 28px;
    color: $theme-color;
    font-weight: 500;

    .map-link {
      margin-left: 15px;
      
      &:hover { 
        cursor: pointer;
      }
    }
  }

  img {
    box-shadow: rgba(0, 0, 0, 0.30) 0px 19px 38px, 
    rgba(0, 0, 0, 0.22) 0px 15px 12px;
    border-radius: 5px;
  }
}
.contact-icon {
  color: red;
}
</style>